export const BATCH_REFETCH_INTERVAL_MS = 5000;

const IN_PROGRESS_STATUSES = ['pending', 'processing'];

export const batchStatusLabels: Record<string, string> = {
  pending: 'Pendente',
  processing: 'Processando',
  completed: 'Concluído',
  completed_with_errors: 'Concluído com erros',
  failed: 'Falhou',
  interrupted: 'Interrompido',
};

export const batchStatusClasses: Record<string, string> = {
  pending: 'bg-[var(--inactive)] text-[var(--inactive-dark)]',
  processing: 'bg-[var(--secondary)] text-[var(--primary)]',
  completed: 'bg-[var(--active)] text-[var(--active-dark)]',
  completed_with_errors: 'bg-amber-100 text-amber-800',
  failed: 'bg-red-100 text-red-800',
  interrupted: 'bg-red-100 text-red-800',
};

export const batchActionTypeLabels: Record<string, string> = {
  replace_default_campaign: 'Troca de campanha padrão',
  replace_schedule_campaign: 'Troca de agendamento',
};

export const batchItemStatusLabels: Record<string, string> = {
  pending: 'Pendente',
  processing: 'Processando',
  succeeded: 'Concluído',
  failed: 'Falhou',
};

export function batchItemStatusLabel(item: { status: string; notProcessed: boolean; interrupted: boolean }) {
  if (item.notProcessed) return 'Não processado';
  if (item.interrupted) return 'Interrompido';
  return batchItemStatusLabels[item.status] ?? item.status;
}

export function isBatchInProgress(status: string) {
  return IN_PROGRESS_STATUSES.includes(status);
}

export function batchRefetchInterval(statuses: string[] | undefined) {
  return statuses?.some(isBatchInProgress) ? BATCH_REFETCH_INTERVAL_MS : false;
}
